import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Grid,
  IconButton,
  makeStyles,
  Menu,
  Paper,
  Theme,
  Typography,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import CloseIcon from "@material-ui/icons/Close";
import DescriptionIcon from "@material-ui/icons/Description";
import PublishIcon from "@material-ui/icons/Publish";
import VideocamIcon from "@material-ui/icons/Videocam";
import managerFilesApi from "api/managerFiles";
import managerLessonApi from "api/managerLesson";
import { useAppDispatch, useAppSelector } from "app/hooks";
import EMOJI from "assets/img/emoji.png";
import ICON_VIDEO from "assets/img/icon_video.png";
import CheckboxField from "components/FormFields/CheckboxField";
import InputField from "components/FormFields/InputField";
import { SelectField } from "components/FormFields/SelectFiled";
import Picker, { SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";
import {
  fetchCategoryList,
  selectCategoryList,
} from "features/Admin/pages/ManagerCategory/managerCategorySlice";
import { ResponseStatus } from "models/common";
import { CreateLesson, Lesson } from "models/managerLesson";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: "0 24px 48px 24px",
    maxWidth: 1200,
    margin: "0 auto",
    boxSizing: "border-box",
    [theme.breakpoints?.down("md")]: {
      padding: "0 12px 24px 12px",
    },
  },
  headerBanner: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E1B4B 50%, #312E81 100%)",
    borderRadius: 24,
    padding: "24px 32px",
    color: "#FFFFFF",
    marginBottom: 24,
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 12px 32px rgba(15, 23, 42, 0.15)",
    display: "flex",
    alignItems: "center",
    gap: 16,
    [theme.breakpoints?.down("md")]: {
      padding: "16px 20px",
      borderRadius: 16,
      marginBottom: 16,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-40%",
      right: "-10%",
      width: 300,
      height: 300,
      background:
        "radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(99, 102, 241, 0) 70%)",
      pointerEvents: "none",
    },
  },
  btnBack: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    backdropFilter: "blur(8px)",
    color: "#FFFFFF",
    borderRadius: 12,
    padding: "8px 16px",
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "none",
    transition: "all 0.2s ease",
    zIndex: 2,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.25)",
      transform: "translateX(-2px)",
    },
  },
  bannerTitle: {
    color: "#FFFFFF",
    fontSize: "1.5rem",
    fontWeight: 800,
    zIndex: 2,
    [theme.breakpoints?.down("md")]: {
      fontSize: "1.125rem",
    },
  },
  sectionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    padding: 28,
    marginBottom: 24,
    border: "1px solid #E2E8F0",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.03)",
    [theme.breakpoints?.down("sm")]: {
      padding: 18,
      borderRadius: 16,
      marginBottom: 16,
    },
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottom: "1px solid #F1F5F9",
  },
  sectionTitle: {
    fontWeight: 800,
    fontSize: "1.0625rem",
    color: "#0F172A",
  },
  fieldLabel: {
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#334155",
    marginBottom: 6,
    display: "block",
  },
  dropzoneWrapper: {
    border: "2px dashed #CBD5E1",
    borderRadius: 16,
    backgroundColor: "#F8FAFC",
    padding: 32,
    textAlign: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#EEF2FF",
      borderColor: "#818CF8",
    },
  },
  dropzoneContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  dropzoneIcon: {
    width: 64,
    height: 64,
    marginBottom: 8,
  },
  dropzoneText: {
    fontSize: "0.9375rem",
    fontWeight: 700,
    color: "#1E293B",
  },
  dropzoneSubtext: {
    fontSize: "0.8125rem",
    color: "#64748B",
  },
  videoPreviewWrapper: {
    position: "relative",
    borderRadius: 16,
    overflow: "hidden",
    backgroundColor: "#0F172A",
    maxHeight: 450,
  },
  closePreviewBtn: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 10,
    backgroundColor: "rgba(15, 23, 42, 0.7)",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(15, 23, 42, 0.9)",
    },
  },
  actionBar: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 12,
    marginTop: 32,
  },
  btnCancel: {
    backgroundColor: "#F1F5F9",
    color: "#334155",
    borderRadius: 12,
    padding: "10px 24px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "0.9375rem",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#E2E8F0",
      color: "#0F172A",
    },
  },
  btnSave: {
    background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
    color: "#FFFFFF",
    borderRadius: 12,
    padding: "10px 28px",
    fontWeight: 700,
    textTransform: "none",
    fontSize: "0.9375rem",
    boxShadow: "0 4px 14px rgba(15, 23, 42, 0.25)",
    transition: "all 0.2s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #1E293B 0%, #334155 100%)",
      transform: "translateY(-1px)",
    },
  },
  icon_emoji: {
    position: "absolute",
    bottom: 8,
    right: 8,
    "& >span >img": {
      width: 24,
      height: 24,
    },
  },
}));

export default function EditLesson() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location: any = useLocation();

  const isPostedPathname = location?.state?.type === "POSTED";
  const detailLesson: Lesson = location.state?.detailLesson || {};
  const listCategory = useAppSelector(selectCategoryList);

  const [isPostNow, setIsPostNow] = useState(false);
  const [disableDate, setDisableDate] = useState(false);
  const [errorVideo, setErrorVideo] = useState("");
  const [video, setVideo] = useState(detailLesson?.attachment?.url || "");
  const [filePPTX, setFilePPTX] = useState<any>(
    detailLesson?.powerPointFileList?.[0] || ""
  );
  const [idFilePTTX, setIdFilePPTX] = useState<any>("");
  const [fileVideo, setFileVideo] = useState("");
  const [openEmoji, setOpenEmoji] = useState<null | HTMLElement>(null);

  const schema = yup.object().shape({
    publishDate: yup.string().when("postNow", {
      is: false,
      then: yup.string().required(`${t("managerLesson.vuilongchonngaydang")}`),
    }),
    lessionCategoryId: yup
      .string()
      .required(`${t("managerLesson.vuilongchonchude")}`),
    lessionDescription: yup
      .string()
      .required(`${t("managerLesson.vuilongchonmota")}`),
    lessionTitle: yup
      .string()
      .required(`${t("managerLesson.vuilongnhaptenbaihoc")}`),
  });

  const getPublishDateTimeInitial = () => {
    if (!detailLesson?.publishDate) return "";
    const pubDateStr = String(detailLesson.publishDate);
    const yyyymmdd = pubDateStr.includes("-")
      ? pubDateStr
      : `${pubDateStr.slice(0, 4)}-${pubDateStr.slice(4, 6)}-${pubDateStr.slice(-2)}`;

    let hhmm = "00:00";
    if (detailLesson?.publishTime) {
      const timeStr = String(detailLesson.publishTime).padStart(4, "0");
      hhmm = `${timeStr.slice(0, 2)}:${timeStr.slice(2, 4)}`;
    }
    return `${yyyymmdd}T${hhmm}`;
  };

  const getHiddenDateTimeInitial = () => {
    const lesson = detailLesson as any;
    if (!lesson?.expiryTimestamp && !lesson?.expiryDate && !lesson?.expiryDateTimeAsString) return "";
    if (lesson?.expiryTimestamp) {
      return moment(lesson.expiryTimestamp).format("YYYY-MM-DDTHH:mm");
    }
    if (lesson?.expiryDateTimeAsString) {
      return moment(lesson.expiryDateTimeAsString).format("YYYY-MM-DDTHH:mm");
    }
    const expDateStr = String(lesson.expiryDate || "");
    if (!expDateStr) return "";
    const yyyymmdd = expDateStr.includes("-")
      ? expDateStr
      : `${expDateStr.slice(0, 4)}-${expDateStr.slice(4, 6)}-${expDateStr.slice(-2)}`;
    let hhmm = "00:00";
    if (lesson?.expiryTime) {
      const timeStr = String(lesson.expiryTime).padStart(4, "0");
      hhmm = `${timeStr.slice(0, 2)}:${timeStr.slice(2, 4)}`;
    }
    return `${yyyymmdd}T${hhmm}`;
  };

  const initialValues: CreateLesson = {
    postNow: false,
    isAll: detailLesson?.isAll || true,
    publishDate: getPublishDateTimeInitial(),
    publishTime: "",
    lessionCategoryId: detailLesson?.lessionCategoryId
      ? String(detailLesson.lessionCategoryId)
      : "",
    hiddenDate: getHiddenDateTimeInitial(),
    hiddenTime: "",
    lessionDescription: detailLesson?.lessionDescription || "",
    lessionTitle: detailLesson?.lessionName || "",
    areaId: detailLesson?.areaId ? String(detailLesson.areaId) : "",
    workTypeId: detailLesson?.workTypeId ? String(detailLesson.workTypeId) : "",
    departmentId: detailLesson?.departmentId
      ? String(detailLesson.departmentId)
      : "",
  };

  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleOpenEmoji = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenEmoji(event.currentTarget);
  };

  const onEmojiClick = (event: any, emojiObject: any) => {
    setValue(
      "lessionDescription",
      getValues().lessionDescription + emojiObject.emoji
    );
  };

  useEffect(() => {
    dispatch(fetchCategoryList());
  }, [dispatch]);

  useEffect(() => {
    if (isPostNow) {
      setValue("publishDate", "");
      setDisableDate(true);
    } else {
      setDisableDate(false);
    }
  }, [isPostNow, setValue]);

  useEffect(() => {
    if (video !== "") {
      setErrorVideo("");
    }
  }, [video]);

  const handleSubmitForm = async (value: CreateLesson) => {
    if (video === "" && filePPTX === "") {
      setErrorVideo(`${t("managerLesson.vuilongchonvideobaihoc")}`);
      return;
    }

    let pubDate = "";
    let pubTime = "";
    if (value.postNow) {
      pubDate = moment(new Date()).format("YYYYMMDD");
      pubTime = moment(new Date()).format("HHmm");
    } else if (value.publishDate) {
      if (value.publishDate.includes("T")) {
        const [d, tStr] = value.publishDate.split("T");
        pubDate = d.split("-").join("");
        pubTime = tStr.split(":").join("");
      } else {
        pubDate = value.publishDate.split("-").join("");
        pubTime = value.publishTime ? value.publishTime.split(":").join("") : "";
      }
    }

    let hidDate = "";
    let hidTime = "";
    if (value.hiddenDate) {
      if (value.hiddenDate.includes("T")) {
        const [d, tStr] = value.hiddenDate.split("T");
        hidDate = d.split("-").join("");
        hidTime = tStr.split(":").join("");
      } else {
        hidDate = value.hiddenDate.split("-").join("");
        hidTime = value.hiddenTime ? value.hiddenTime.split(":").join("") : "";
      }
    }

    const newValue = {
      ...value,
      isAll: "Y",
      publishDate: pubDate,
      publishTime: pubTime,
      lessionId: String(detailLesson.id),
      hiddenDate: hidDate,
      hiddenTime: hidTime,
    };

    const formData = new FormData();
    formData.append("publishDate", newValue.publishDate);
    formData.append("publishTime", newValue.publishTime);
    if (hidDate && hidDate !== "Invalid date")
      formData.append("expiryDate", newValue.hiddenDate);
    if (hidTime && hidTime !== "Invalid date")
      formData.append("expiryTime", newValue.hiddenTime);

    formData.append("isAll", newValue.isAll);
    formData.append("lessionCategoryId", newValue.lessionCategoryId);
    formData.append("lessionDescription", newValue.lessionDescription);
    fileVideo && !isPostedPathname && formData.append("video", fileVideo);
    formData.append("lessionTitle", newValue.lessionTitle);
    formData.append("lessionId", newValue.lessionId);
    idFilePTTX.length > 0 && formData.append("powerPointFileIDList", idFilePTTX);

    try {
      const res: ResponseStatus = await managerLessonApi.updateLesson(formData);
      if (res.responseCode === "00") {
        toast.success(`${t("managerLesson.capnhatbaihocthanhcong")}`);
        location?.state?.type === "FUTURE"
          ? navigate("/admin/manager-lesson/listFuture")
          : location?.state?.type === "POSTED"
          ? navigate("/admin/manager-lesson/listPosted")
          : navigate("/admin/manager-lesson/listDraft");
      } else {
        toast.error(`${t("managerLesson.capnhatbaihocthatbai")}`);
      }
    } catch (error) {
      toast.error(`${t("managerLesson.capnhatbaihocthatbai")}`);
    }
  };

  const handleChangeFile = async (acceptedFiles: any) => {
    if (
      acceptedFiles[0].type !== "video/mp4" &&
      !acceptedFiles[0].path.includes(".pptx")
    ) {
      setErrorVideo(`${t("managerLesson.tepkhongdungdinhdang")}`);
      return;
    }
    if (acceptedFiles[0].size > 500e7) {
      setErrorVideo(`${t("managerLesson.dungluongtoida")}`);
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(acceptedFiles[0]);
    const formData = new FormData();

    if (acceptedFiles[0].type === "video/mp4") {
      setFileVideo(acceptedFiles[0]);
      reader.onload = () => {
        setVideo(URL.createObjectURL(acceptedFiles[0]));
      };
    } else {
      try {
        acceptedFiles.forEach((acceptedFile: any) => {
          formData.append("attachments", acceptedFile);
        });

        const data = await managerFilesApi.uploadFiles(formData);
        const pptxFile = data?.body?.attachmentList?.[0];
        if (pptxFile) {
          setFilePPTX({
            id: pptxFile.id,
            powerPointFile: {
              url: pptxFile.url,
            },
          });
          setIdFilePPTX(pptxFile.id);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Box className={classes.container}>
      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Button
          className={classes.btnBack}
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Quay lại
        </Button>
        <Typography className={classes.bannerTitle}>
          CHỈNH SỬA BÀI HỌC
        </Typography>
      </Box>

      <form onSubmit={handleSubmit(handleSubmitForm)}>
        {/* Section 1: Lịch đăng & Lịch ẩn */}
        <Paper elevation={0} className={classes.sectionCard}>
          <Box className={classes.sectionHeader}>
            <CalendarTodayIcon style={{ color: "#4F46E5", fontSize: 22 }} />
            <Typography className={classes.sectionTitle}>
              CẤU HÌNH THỜI GIAN ĐĂNG & ẨN
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {/* Lịch đăng */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.lichdang")}
              </Typography>
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="publishDate"
                disabled={disableDate}
                size="small"
                borderRadius="12px"
              />
              <Box mt={1}>
                <CheckboxField
                  name="postNow"
                  label={t("managerLesson.dangngay")}
                  control={control}
                  handleChange={setIsPostNow}
                />
              </Box>
            </Grid>

            {/* Lịch ẩn */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.lichan")}
              </Typography>
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="hiddenDate"
                size="small"
                borderRadius="12px"
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Section 2: Thông tin nội dung bài học */}
        <Paper elevation={0} className={classes.sectionCard}>
          <Box className={classes.sectionHeader}>
            <DescriptionIcon style={{ color: "#0284C7", fontSize: 22 }} />
            <Typography className={classes.sectionTitle}>
              THÔNG TIN NỘI DUNG BÀI HỌC
            </Typography>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.chude")} *
              </Typography>
              <SelectField
                name="lessionCategoryId"
                label={t("managerLesson.chude")}
                options={listCategory}
                control={control}
                borderRadius="12px"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.tenbaihoc")} *
              </Typography>
              <InputField
                name="lessionTitle"
                label={t("managerLesson.tenbaihoc") + "..."}
                control={control}
                size="small"
                borderRadius="12px"
              />
            </Grid>

            <Grid item xs={12}>
              <Typography className={classes.fieldLabel}>
                {t("managerLesson.mota")} *
              </Typography>
              <Box position="relative" width="100%">
                <InputField
                  name="lessionDescription"
                  label={t("managerLesson.mota")}
                  control={control}
                  rows={3}
                  multiline
                  size="small"
                  borderRadius="12px"
                />
                <IconButton
                  onClick={handleOpenEmoji}
                  className={classes.icon_emoji}
                >
                  <img src={EMOJI} alt="EMOJI" />
                </IconButton>

                {openEmoji && (
                  <Menu
                    id="emoji-menu"
                    anchorEl={openEmoji}
                    keepMounted
                    open={Boolean(openEmoji)}
                    onClose={() => setOpenEmoji(null)}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                  >
                    <Picker
                      onEmojiClick={onEmojiClick}
                      disableAutoFocus={true}
                      skinTone={SKIN_TONE_MEDIUM_DARK}
                      groupNames={{ smileys_people: "PEOPLE" }}
                      native
                    />
                  </Menu>
                )}
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {/* Section 3: Tải lên Video / Slide PowerPoint */}
        <Paper elevation={0} className={classes.sectionCard}>
          <Box className={classes.sectionHeader}>
            <VideocamIcon style={{ color: "#16A34A", fontSize: 22 }} />
            <Typography className={classes.sectionTitle}>
              TẢI LÊN VIDEO HOẶC SLIDE POWERPOINT (.MP4 / .PPTX)
            </Typography>
          </Box>

          <Dropzone onDrop={handleChangeFile}>
            {({ getRootProps, getInputProps }) => (
              <Box position="relative">
                {video === "" && filePPTX === "" && (
                  <Box {...getRootProps()} className={classes.dropzoneWrapper}>
                    <input
                      {...getInputProps()}
                      accept="video/* ,.pptx"
                      multiple={false}
                    />
                    <Box className={classes.dropzoneContent}>
                      <img
                        src={ICON_VIDEO}
                        alt="ICON_VIDEO"
                        className={classes.dropzoneIcon}
                      />
                      <Typography className={classes.dropzoneText}>
                        {t("managerLesson.themvideo")}
                      </Typography>
                      <Typography className={classes.dropzoneSubtext}>
                        {t("managerLesson.hoackeotha")}
                      </Typography>
                    </Box>
                  </Box>
                )}

                {/* Preview Video */}
                {video !== "" && (
                  <Box className={classes.videoPreviewWrapper}>
                    <IconButton
                      className={classes.closePreviewBtn}
                      onClick={() => setVideo("")}
                    >
                      <CloseIcon />
                    </IconButton>
                    <ReactPlayer
                      url={video}
                      controls={true}
                      width="100%"
                      height="400px"
                      config={{
                        file: { attributes: { controlsList: "nodownload" } },
                      }}
                      onContextMenu={(e: any) => e.preventDefault()}
                    />
                  </Box>
                )}

                {/* Preview PowerPoint */}
                {filePPTX !== "" && (
                  <Box className={classes.videoPreviewWrapper}>
                    <IconButton
                      className={classes.closePreviewBtn}
                      onClick={() => setFilePPTX("")}
                    >
                      <CloseIcon />
                    </IconButton>
                    <iframe
                      title="powerpoint-view"
                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${
                        filePPTX?.powerPointFile?.url || filePPTX?.url || ""
                      }`}
                      width="100%"
                      height="500px"
                      style={{ border: "none" }}
                    />
                  </Box>
                )}
              </Box>
            )}
          </Dropzone>

          {errorVideo !== "" && (
            <Typography
              variant="subtitle2"
              color="secondary"
              style={{ marginTop: 12, fontWeight: 700 }}
            >
              {errorVideo}
            </Typography>
          )}
        </Paper>

        {/* Action Buttons Bar */}
        <Box className={classes.actionBar}>
          <Button
            className={classes.btnCancel}
            onClick={() => navigate(-1)}
          >
            Hủy bỏ
          </Button>

          <Button
            type="submit"
            className={classes.btnSave}
            startIcon={<PublishIcon />}
          >
            Cập nhật bài học
          </Button>
        </Box>
      </form>
    </Box>
  );
}
